<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item class="query-form-item" label="InvestorName:">
                <el-input v-model="query.investorName" placeholder="Investor Name">
                </el-input>
            </el-form-item>
            <el-form-item class="query-form-item" label="Chinese Name:">
                <el-input v-model="query.chineseName" placeholder="Chinese Name">
                </el-input>
            </el-form-item>
            <el-form-item class="query-form-item" label="Fund Full Name:">
                <el-input v-model="query.fundFullName" placeholder="Fund Full Name">
                </el-input>
            </el-form-item>
            <el-form-item class="query-form-item" label="Class Name:">
                <el-input v-model="query.className" placeholder="Class Name">
                </el-input>
            </el-form-item>
            <el-form-item class="query-form-item" label="amount:">
                <el-input v-model="query.amount" placeholder="amount">
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" icon="el-icon-refresh" @click="onReset">
                    </el-button>
                    <el-button type="primary" icon="search" @click="onSubmit">
                        Search
                    </el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;">
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column label="Id" prop="subscriptionId" min-width="3%" :key="Math.random()">
                </el-table-column>
                <el-table-column label="InvestorId" prop="investorId" min-width="10%">
                </el-table-column>
                <el-table-column label="Investor Name" prop="investorName" min-width="15%">
                </el-table-column>
                <el-table-column label="ChineseName" prop="chineseName" min-width="10%">
                </el-table-column>
                <el-table-column label="CRSID" prop="CRSID" min-width="15%">
                </el-table-column>
                <el-table-column label="Fund Name" prop="fundName" min-width="25%">
                </el-table-column>
                <el-table-column label="Amount" prop="amount" min-width="10%">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.currency }}
                            {{ scope.row.amount | numFilter }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" min-width="10%">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click.native="handleForm(scope.$index, scope.row)">
                            <i class="el-icon-view">Detail</i>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-scrollbar>

        <el-pagination :page-size="query.limit" @current-change="handleCurrentChange" layout="prev, pager, next"
            :total="total">
        </el-pagination>

        <!--表单-->
        <el-dialog title="详情" :visible.sync="formVisible" :before-close="hideForm" width="85%" top="5vh"
            :close-on-click-modal="false">
            <el-form :model="formData" ref="dataForm">
                <el-col :span="12">
                    <el-form-item label="Id" prop="subscriptionId" label-width="150px" label-position="left">
                        <el-input v-model="formData.subscriptionId" auto-complete="off"></el-input>
                    </el-form-item>

                    <el-form-item label="chineseName" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.chineseName"></el-input>
                    </el-form-item>
                    <el-form-item label="investorName" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.investorName"></el-input>
                    </el-form-item>
                    <el-form-item label="firstName" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.firstName"></el-input>
                    </el-form-item>
                    <el-form-item label="lastName" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.lastName"></el-input>
                    </el-form-item>
                    <el-form-item label="englishName" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.englishName"></el-input>
                    </el-form-item>
                    <el-form-item label="" label-width="150px" label-position="left">
                        ============ ID INFO ==========================<br />
                    </el-form-item>
                    <el-form-item label="IDType" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.IDIDType"></el-input>
                    </el-form-item>

                    <el-form-item label="IDNumber" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.IDIDNumber"></el-input>
                    </el-form-item>

                    <el-form-item label="FirstName" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.IDFirstName"></el-input>
                    </el-form-item>
                    <el-form-item label="LastName" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.IDLastName"></el-input>
                    </el-form-item>

                    <el-form-item label="EnglishName" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.IDEnglishName"></el-input>
                    </el-form-item>
                    <el-form-item label="ChineseName" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.IDChineseName"></el-input>
                    </el-form-item>

                    <el-form-item label="Name" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.IDName"></el-input>
                    </el-form-item>
                    <el-form-item label="Address" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.IDAddress"></el-input>
                    </el-form-item>

                    <el-form-item label="EnglishAddress" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.IDEnglishAddress"></el-input>
                    </el-form-item>
                    <el-form-item label="Nationality" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.IDNationality"></el-input>
                    </el-form-item>
                    <el-form-item label="Sex" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.IDSex"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="fundName" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.fundName"></el-input>
                    </el-form-item>
                    <el-form-item label="className" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.className"></el-input>
                    </el-form-item>
                    <el-form-item label="series" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.series"></el-input>
                    </el-form-item>
                    <el-form-item label="currency" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.currency"></el-input>
                    </el-form-item>
                    <el-form-item label="amount" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.amount"></el-input>
                    </el-form-item>
                    <el-form-item label="subscriptionFee" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.subscriptionFee"></el-input>
                    </el-form-item>
                    <el-form-item label="" label-width="150px" label-position="left">
                        ============ Address INFO ==========================<br />
                    </el-form-item>
                    <!-- <el-form-item label="CertificateId" label-width=150px label-position="left">
                        <el-input type="" v-model="formData.addrCertificateId"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="CertificateType" label-width=150px label-position="left">
                        <el-input type="" v-model="formData.addrCertificateType"></el-input>
                    </el-form-item> -->
                    <el-form-item label="IDType" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.addrIDType"></el-input>
                    </el-form-item>

                    <el-form-item label="IDNumber" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.addrIDNumber"></el-input>
                    </el-form-item>

                    <el-form-item label="FirstName" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.addrFirstName"></el-input>
                    </el-form-item>
                    <el-form-item label="LastName" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.addrLastName"></el-input>
                    </el-form-item>

                    <el-form-item label="EnglishName" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.addrEnglishName"></el-input>
                    </el-form-item>
                    <el-form-item label="ChineseName" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.addrChineseName"></el-input>
                    </el-form-item>

                    <el-form-item label="Name" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.addrName"></el-input>
                    </el-form-item>
                    <el-form-item label="Address" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.addrAddress"></el-input>
                    </el-form-item>

                    <el-form-item label="EnglishAddress" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.addrEnglishAddress"></el-input>
                    </el-form-item>
                    <el-form-item label="Nationality" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.addrNationality"></el-input>
                    </el-form-item>
                    <el-form-item label="Sex" label-width="150px" label-position="left">
                        <el-input type="" v-model="formData.addrSex"></el-input>
                    </el-form-item>
                </el-col>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { investorSubscriptionList } from "../../api/fund/investorSubscription";
    import draggable from "vuedraggable";
    const formJson = {
        id: "",
        lastStatus: "",
    };

    export default {
        data() {
            return {
                roles: [],
                query: {
                    investorName: "",
                    page: 1,
                    limit: 10,
                },
                list: [],
                total: 0,
                loading: true,
                index: null,
                formName: null,
                formLoading: false,
                formVisible: false,
                formData: formJson,
                formRules: {},
                deleteLoading: false,
                lastStatus: "",
            };
        },
        components: {
            draggable,
        },
        methods: {
            onReset() {
                this.$router.push({
                    path: "",
                });
                this.query = {
                    company: "",
                    status: "ALL",
                    page: 1,
                    limit: 10,
                };
                this.getList();
            },
            onSubmit() {
                this.getList();
            },
            handleCurrentChange(val) {
                this.query.page = val;
                this.getList();
            },

            getList() {
                this.loading = true;
                investorSubscriptionList(this.query)
                    .then((response) => {
                        this.loading = false;
                        if (response.code) {
                            this.$message.error(response.message);
                            return;
                        }
                        this.list = response.data.list || [];
                        this.total = response.data.total || 0;
                    })
                    .catch(() => {
                        this.loading = false;
                        this.list = [];
                        this.total = 0;
                        this.roles = [];
                    });
            },

            // formSubmit() {
            //     //this.$message.success("开始提交");
            //     this.$refs["dataForm"].validate(valid => {

            //         if (valid) {

            //             this.formLoading = true;
            //             let data = Object.assign({}, this.formData);

            //             if(data.status==data.lastStatus){
            //                 this.$message.success("审核状态相同！");
            //             }

            //             let addData = Object.assign({}, this.formData);
            //             //this.$message.info("编辑");
            //             invoiceSaveOrEdit(data, this.formName)
            //                 .then(response => {
            //                     this.formLoading = false;
            //                     if (response.code) {
            //                         this.$message.error(response.message);
            //                         return false;
            //                     }
            //                     this.$message.success("操作成功");
            //                     this.formVisible = false;
            //                     if (this.formName === "add") {
            //                         // 向头部添加数据
            //                         addData.invoiceId = response.data.invoiceId;
            //                         this.list.unshift(addData);
            //                     } else {
            //                         this.list.splice(this.index, 1, addData);
            //                     }
            //                     // 刷新表单
            //                     this.resetForm();
            //                 })
            //                 .catch(() => {
            //                     this.formLoading = false;
            //                 });
            //         }else{
            //             this.$message.success("验证失败");
            //         }
            //     });
            // },

            // 显示表单
            handleForm(index, row) {
                //this.$message.success("显示审核！");
                this.formVisible = true;
                this.formData = JSON.parse(JSON.stringify(formJson));
                if (row !== null) {
                    this.formData = Object.assign({}, row);
                }
                if (index !== null) {
                    this.index = index;
                    this.formName = "edit";
                }
            },
            // 隐藏表单
            hideForm() {
                // 更改值
                this.formVisible = !this.formVisible;
                return true;
            },
        },
        filters: {
            cutDetail(detail) {
                if (detail != null && detail.length > 60) {
                    detail = detail.substr(0, 115) + "...";
                }
                return detail;
            },
            statusFilterType(status) {
                const statusMap = {
                    0: "gray",
                    1: "success",
                    2: "danger",
                };
                return statusMap[status];
            },
            numFilter(value) {
                let realvalue = parseFloat(value).toFixed(2);
                return realvalue;
            },
        },
        mounted() { },
        created() {
            // 将参数拷贝进查询对象
            let query = this.$route.query;
            this.query = Object.assign(this.query, query);
            this.query.limit = parseInt(this.query.limit);
            // 加载表格数据
            this.getList();
        },
    };
</script>

<style type="text/scss" lang="scss"></style>